export const defSubmitData = {
  thirdparty_category_cn_name: "",
  base_description: "",
  package_description: "",
  etc_property_descriptions: [],
  chinese_name: "",
  english_name: "",
  brands_name: "",
  thirdparty_season_label_name: [],
  thirdparty_category_id: 0,
  thirdparty_category_name: "",
  thirdparty_old_category_id: 0,
  thirdparty_old_category_name: "",
  forecast_length: 0,
  forecast_width: 0,
  forecast_height: 0,
  new_product_type: 0,
  thirdparty_clothing_style_id: 0,
  thirdparty_clothing_style_name: "",
  thirdparty_clothing_elasticity_id: 0,
  thirdparty_clothing_elasticity_name: "",
  thirdparty_clothing_category_id: 0,
  thirdparty_clothing_category_name: "",
  thirdparty_clothing_second_category_id: 0,
  thirdparty_clothing_second_category_name: "",
  clothing_composition_name: "",
  thirdparty_tag_size_id: 0,
  thirdparty_tag_size_name: "",
  thirdparty_suitable_age_name: [],
  certification_link: [],
  certification_ids: [],
  poa_size_type: 0,
  poa_color: "",
  poa_size: "",
  thirdparty_feature_callout: [],
  img_link: [],
  default_img_link: "",
  img_ids: [],
  poa_infos: [
    {
      poa_size_type: 0,
      box_length: 0,
      box_width: 0,
      box_high: 0,
      thirdparty_feature_callout: [],
      arrival_days: 0,
      min_num: 0,
      price: 0,
      status: 1,
      weight: 0,
      poa_color: "",
      poa_size: "",
      property_images: [],
    },
  ],
  del_poa: [],
  product_link: "无",
  weight: 0,
  min_num: 0,
  qq: "",
  price: 0,
  arrival_days: 0,
  is_exemptpostage: 0,
  ali_wangwang: "",
  box_able: 0,
  status: 1,
  ewd_recommend_type: 0,
};
